import { createSlice } from '@reduxjs/toolkit';

export const categorySlice = createSlice({
    name: 'category',
    initialState: {
        data: null,
    },
    reducers: {
        setCategories: (state, {payload}) => {
            state.data = payload;
        }
    },
});

export const {
    setCategories,
} = categorySlice.actions;

export default categorySlice.reducer;
